class ReviewRatingsViewMarkup {
  static getMarkupFor(ratingsByGroups, attributes = []) {
    let markup = '';

    for (let ratingGroup of ratingsByGroups) {
      let contentMarkup = '';
      for (let rating of ratingGroup.ratings) {
        contentMarkup += this.getControlMarkup(rating, ratingGroup.ratings);
      }
      markup += this.getGroupMarkup(
        ratingGroup.id,
        ratingGroup.label,
        contentMarkup
      );
    }

    for (let attribute of attributes) {
      markup += this.getGroupMarkup(
        attribute.name,
        attribute.title,
        `<collapsible-text attribute-id='${attribute.name}'
                           value='${attribute.values.join(', ')}'
                           class='review-attributes'
                           max-line-count='2'></collapsible-text>`
      );
    }
    return markup;
  }

  static getGroupMarkup(id, label, contentMarkup = '') {
    return `
        <div rating-group-id=${id}
             class='review-rating-group'>
          <div class='review-rating-group-label'>${label}</div>
          <div class='review-rating-group-item-container'>${contentMarkup}</div>
        </div>
      `;
  }

  static getControlMarkup(rating, siblingRatings) {
    let ratingLabel = rating.label;
    let ratingValue = rating.value;

    if (rating.view) {
      if (rating.view == 'none') {
        return '';
      }

      ratingLabel = rating.view.label ?? '';
      ratingValue =
        rating.view.value?.replace(/\{(.*?)\}/g, (match, id) => {
          let siblingRating = siblingRatings.find(r => r.id == id);
          return siblingRating?.value ?? '0';
        }) ?? '';
    }

    let imageMarkup = `<img src='${
      rating.image ?? '/images/app_icons.svg#no_image'
    }'>`;

    let markup = '';
    switch (rating.type) {
      case 'boolean':
        markup = `
          <label class='boolean'
                 rating-id='${rating.id}'>${imageMarkup}${ratingLabel}</label>`;
        break;

      case 'range':
        markup = `
          <label rating-id='${rating.id}'>
            ${ratingLabel}: ${ratingValue}</label>`;
        break;

      case 'rating':
        {
          let classes = rating.imageClass ? `origin ${rating.imageClass}` : '';
          markup = `
            <rating-control rating-id='${rating.id}'
                            class='${classes}'
                            readonly='true'
                            label='${ratingLabel}: '
                            value='${ratingValue}'
                            ${
                              (rating.scale &&
                                `scale-labels='${rating.scale}'`) ||
                              ''
                            }></rating-control>`;
        }
        break;

      case 'text':
        markup = `
          <label rating-id='${rating.id}'>${imageMarkup}${ratingValue}</label>`;
        break;
    }
    return markup;
  }

  static get selectors() {
    const Attributes = '.review-attributes';
    return {
      Attributes,
      AttributeBy: attributeId =>
        `${Attributes}[attribute-id='${attributeId}']`,
      RatingGroupLabels: `[rating-group-id] > .review-rating-group-label`,
      RatingGroupValues: `[rating-group-id] > .review-rating-group-item-container > collapsible-text`,
      RatingGroupBy: groupId => `[rating-group-id='${groupId}']`,
      RatingControlBy: ratingId => `[rating-id='${ratingId}']`,
      RatingGroupItemContainers: '.review-rating-group-item-container',
    };
  }
}

export { ReviewRatingsViewMarkup };
